if (!customElements.get('ck-set-builder')) {
  customElements.define('ck-set-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-ck-data]').textContent);
      this.text = this.data.text;
      this.details = this.querySelector('details');
      this.container = this.closest('.product__info-container');
      this.button = this.querySelector('[data-ck-add]');
      this.message = this.querySelector('[data-ck-message]');
      this.cartLink = this.querySelector('[data-ck-cart]');
      this.line = Object.keys(this.data.lines).find(key => String(this.data.lines[key].id) === this.dataset.productId) || 'madera';
      this.count = this.line === 'cristal' ? 2 : 3;
      this.format = new Intl.NumberFormat('es-UY', {style:'currency',currency:this.dataset.currency || 'UYU',minimumFractionDigits:2,maximumFractionDigits:2});
      this.details.addEventListener('toggle', () => {
        this.container?.classList.toggle('ck-set-open', this.details.open);
        this.container?.querySelector('[data-ck-set-toggle]')?.setAttribute('aria-expanded',String(this.details.open));
        this.dispatchEvent(new CustomEvent('ck:set-change',{bubbles:true}));
      });
      this.handleToggle = event => {
        if (event.target.closest('[data-ck-set-toggle]')) {
          if (!this.details.open) {
            this.dataset.selectedVariant = this.container?.querySelector('product-form input[name="id"]')?.value || this.dataset.selectedVariant;
            this.renderSizes();
          }
          this.details.open = !this.details.open;
        } else if (event.target.closest('variant-selects label, variant-selects input[type="radio"]')) {
          this.details.open = false;
        }
      };
      this.handleSingle = event => {
        if (event.target.closest('variant-selects')) this.details.open = false;
      };
      this.container?.addEventListener('click',this.handleToggle);
      this.container?.addEventListener('change',this.handleSingle);
      this.querySelector('[data-ck-close]').addEventListener('click', () => {
        this.details.open = false;
        this.container?.querySelector('[data-ck-set-toggle]')?.focus();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ck-size]')) this.update();
      });
      this.button.addEventListener('click', () => this.addSet());
      this.renderSizes();
    }
    disconnectedCallback() {
      this.container?.classList.remove('ck-set-open');
      this.container?.removeEventListener('click',this.handleToggle);
      this.container?.removeEventListener('change',this.handleSingle);
      this.ready = false;
    }
    renderSizes() {
      const crystal = this.line === 'cristal';
      const variants = this.data.lines[this.line].variants;
      const available = variants.filter(v => v.available);
      const preferred = available.find(v => String(v.id) === this.dataset.selectedVariant);
      const chosen = preferred ? [preferred.id] : [];
      this.querySelector('[data-ck-sizes-heading]').textContent = crystal ? this.text.included : 'Elegí los tamaños de tu set';
      const grid = this.querySelector('[data-ck-sizes]');
      grid.replaceChildren();
      variants.forEach(variant => {
        const label = document.createElement('label');
        label.className = 'ck-set__size';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = variant.id;
        input.dataset.ckSize = '';
        input.checked = crystal || chosen.includes(variant.id);
        input.disabled = crystal || !variant.available;
        const span = document.createElement('span');
        span.textContent = variant.title.replace('.', ',').replace(/L$/, ' L');
        label.append(input,span);
        if (!variant.available) {
          const small = document.createElement('small');
          small.textContent = this.text.unavailable;
          label.append(small);
        }
        grid.append(label);
      });
      this.update();
    }
    selectedVariants() {
      const ids = [...this.querySelectorAll('[data-ck-size]:checked')].map(input => Number(input.value));
      return this.data.lines[this.line].variants.filter(v => ids.includes(v.id));
    }
    selectedBundle() {
      if (this.line === 'cristal') return this.data.bundle;
      if (this.count === 4) return this.data.quartet;
      if (this.count !== 3) return null;
      const title = this.selectedVariants().map(v => v.title).join(' + ');
      return this.data.trios.find(v => v.title === title);
    }
    update() {
      const selected = this.selectedVariants();
      this.count = selected.length;
      this.details.setAttribute('data-ck-set-name',`${this.text.pack} de ${this.count} · ${this.text[this.line]}`);
      const crystal = this.line === 'cristal';
      const discounted = crystal || this.count === 3 || this.count === 4;
      const percent = this.count === 4 ? 15 : 10;
      const bundle = this.selectedBundle();
      const complete = crystal ? selected.length === 2 : selected.length >= 2 && selected.length <= 4;
      const inStock = selected.every(v => v.available) && (!discounted || !complete || Boolean(bundle?.id && bundle.available));
      const subtotal = selected.reduce((sum,variant) => sum + variant.price, 0);
      this.total = discounted ? (bundle?.price || 0) : subtotal;
      this.querySelector('[data-ck-offer]').textContent = crystal ? 'Set de 2 · $3.290' : complete ? `Set de ${this.count} · ${discounted ? `${percent}% de descuento` : 'Sin descuento'}` : '3 ollas · 10% / 4 ollas · 15%';
      this.querySelectorAll('[data-ck-size]').forEach(input => {
        const variant = this.data.lines[this.line].variants.find(v => String(v.id) === input.value);
        input.disabled = this.busy || crystal || !variant.available;
      });
      this.querySelector('[data-ck-hint]').textContent = crystal ? '' : complete ? `${selected.length} tamaños elegidos` : 'Elegí al menos 2 tamaños para armar tu set.';
      this.querySelector('[data-ck-regular]').textContent = complete ? this.format.format(subtotal/100) : '—';
      this.querySelector('[data-ck-total]').textContent = complete && this.total ? this.format.format(this.total/100) : '—';
      this.querySelector('[data-ck-saving]').textContent = complete && this.total ? `${this.text.savings} ${this.format.format((subtotal-this.total)/100)}${crystal ? '' : ` · ${percent}%`}` : this.text.choose_sizes;
      this.querySelector('[data-ck-regular]').parentElement.hidden = !discounted;
      this.querySelector('[data-ck-saving]').hidden = !discounted;
      this.querySelector('[data-ck-notice]').hidden = crystal;
      this.querySelector('[data-ck-notice]').textContent = !complete ? 'Elegí 2, 3 o 4 tamaños. Con 3 tenés 10% de descuento y con 4, 15%.' : discounted ? `El precio del set ya incluye el ${percent}% de descuento.` : 'Precio normal: suma de los tamaños elegidos, sin descuento.';
      this.button.disabled = this.busy || !complete || !inStock;
      this.button.textContent = this.busy ? this.text.adding : this.text.add;
      this.message.textContent = !inStock ? this.text.stock_error : '';
      this.cartLink.hidden = true;
      this.querySelectorAll('input[type=radio]').forEach(input => { input.disabled = Boolean(this.busy); });
    }
    async addSet() {
      if (this.busy || this.button.disabled) return;
      const selected = this.selectedVariants();
      const count = this.count;
      const name = `${this.text.pack} de ${count} · ${this.text[this.line]}`;
      const bundle = this.selectedBundle();
      const items = bundle
        ? [{id:bundle.id,quantity:1}]
        : selected.map(variant => ({id:variant.id,quantity:1,properties:{Set:name}}));
      this.busy = true;
      this.update();
      let added = false;
      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart?.getSectionsToRender?.().map(section => section.id) || ['cart-icon-bubble'];
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items,sections,sections_url:window.location.pathname})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.text.error);
        added = true;
        try {
          cart?.classList.remove('is-empty');
          if (cart?.renderContents) cart.renderContents({...data,id:data.items?.[0]?.id});
          else if (data.sections?.['cart-icon-bubble']) {
            const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = html.querySelector('.shopify-section')?.innerHTML || html.body.innerHTML;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{source:'ck-set-builder',cartData:data})).catch(() => {});
          }
          window.CKCartFeedback?.show({title:name},count);
        } catch (error) {
          this.cartLink.hidden = false;
        }
        this.message.textContent = this.text.success;
      } catch (error) {
        this.message.textContent = error.message || this.text.error;
      } finally {
        this.busy = false;
        const message = this.message.textContent;
        this.update();
        this.message.textContent = message;
        this.cartLink.hidden = false;
        if (added) this.cartLink.focus();
      }
    }
  });
}


